import React from "react";
import { Col, Container, Row, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

const NogapRightImage =({data})=>{

    return(
        <>
            <Container>
                <Row id="MobileResponsiveSection">
                    <Col md={5} className="m-0 p-0 bgeYantraOrange rounded-start-5 px-4 py-4" id="NogapContent">
                    <h2 className="fs-48 fs-m-big text-white">
                        {data.NogaprightHeading}
                    </h2>
                    <p className="fst-italic fw-normal fw-md-normal fs-20 fs-m-subHeading text-white">
                        {data.NogaprightSmallpara}
                    </p>
                    <p className="fs-6 fs-md-5 fw-lighter text-white">
                        {data.NogaprightParagraph}
                    </p>

                    
                        <Link className="text-white text-decoration-none" to={data.NogaprightRedirectUrl}>
                        <Button id="btnCTA" className="fw-light px-5 rounded-pill hover:border border-dark">Learn More
                        </Button>
                        </Link>
                    
                    
                    </Col>
                    <Col md={7} className="m-0 p-0">
                    <img className="img-fluid float-end w-100 rounded-end-5" id="nogaprightImg" loading="lazy" src={data.NogaprightImg}/>
                    </Col>
                </Row>
            </Container>
        
        </>
    )
}

export default NogapRightImage;